import { FC } from "react";
import { IParticipant } from "../types";
import { FiTrash2 } from "react-icons/fi";

interface ParticipantListProps {
  participants: IParticipant[];
  onRemove: (index: number) => void;
}

const ParticipantList: FC<ParticipantListProps> = ({
  participants,
  onRemove,
}) => {
  return (
    <div className="flex flex-col py-5 mx-auto items-center">
      {participants.map((participant, index) => (
        <div
          key={index}
          className="flex justify-between w-2/6 items-center p-4 py-5 my-2 border rounded-lg shadow-md"
        >
          <div>
            <h2 className="font-bold text-lg">{participant.name} {participant.lastName}</h2>
            <p>{participant.accommodationTypeName}</p>
            {participant.feeTypeName && (
              <p className="text-sm text-gray-600">{participant.address}</p>
            )}
          </div>
          <button
            className="bg-red-500 text-white p-2 rounded hover:bg-red-600"
            onClick={() => onRemove(index)}
          >
            <FiTrash2 />
          </button>
        </div>
      ))}
    </div>
  );
};

export default ParticipantList;
